__turbopack_context__.v({
  "app": "figma-theme-module-scss-module__hIk2MG__app",
  "theme": "figma-theme-module-scss-module__hIk2MG__theme",
});
